export default function Body({ children }: { children: React.ReactNode}) {
  return (
    <div className="card-body">
      {children}
    </div>
  )
}